import { msg } from '@lingui/core/macro';

import { defineEnum } from '@/shared/patterns/define-enum';

// Enums pelo valor técnico (U33, P22). Arquivo leve: entra nos filtros, que vão para o JS inicial.

/**
 * Status da solicitação no **filtro** (`AuthorizationListContainer.tsx:71-78`): Aprovado, Recusado e
 * Pendente, no masculino, como o legado.
 */
export const AUTHORIZATION_STATUS_FILTER = defineEnum({
  Approved: { label: msg`Aprovado` },
  Refused: { label: msg`Recusado` },
  Pending: { label: msg`Pendente` },
});

/**
 * Status da solicitação na **coluna** (`AuthorizationList.tsx:21-25`): o chip mostra o `statusDisplay`
 * da API (Aprovada, Recusada, Pendente) com a cor pelo texto. Aqui o tom vem do valor técnico e o
 * texto da API fica de reserva para valor desconhecido.
 */
export const AUTHORIZATION_STATUS = defineEnum({
  Approved: { label: msg`Aprovada`, tone: 'ok', icon: 'circle-check' },
  Refused: { label: msg`Recusada`, tone: 'err', icon: 'circle-x' },
  Pending: { label: msg`Pendente`, tone: 'warn', icon: 'hourglass' },
});

/** `EWarrantyExecutionStatus` + `warrantyExecutionStatusOptions` (`types.ts:73-85`); cor em `WL:18-23`. */
export const WARRANTY_EXECUTION_STATUS = defineEnum(
  {
    '0': { label: msg`Não executado`, tone: 'neutral', icon: 'circle-dashed' },
    '1': { label: msg`Executado`, tone: 'ok', icon: 'circle-check' },
    '2': { label: msg`Recusado`, tone: 'err', icon: 'circle-x' },
    '3': { label: msg`Erro`, tone: 'warn', icon: 'triangle-alert' },
  },
  { numeric: true, order: ['0', '1', '2', '3'] },
);

/** `walletOriginOptions` (`types.ts:87-90`). */
export const WALLET_ORIGIN = defineEnum({
  true: { label: msg`Carteira própria UY3` },
  false: { label: msg`Fundos de terceiros` },
});

/** "Solicitado pelo fundo" (`WarrantyExecutionListContainer.tsx:85-92`). */
export const FUND_EXECUTION_REQUESTED = defineEnum({
  true: { label: msg`Solicitado` },
  false: { label: msg`Não solicitado` },
});
